import { render, staticRenderFns } from "./LimitCoupon.vue?vue&type=template&id=74e9c386&"
import script from "./LimitCoupon.vue?vue&type=script&lang=ts&"
export * from "./LimitCoupon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports